module.exports = __webpack_public_path__ + "img/b71f13b.jpg";